import React, { useEffect, useRef } from "react";
import logo from "../assets/images/logo.svg";
import Basket from "components/basket";
import LkButton from "components/lk/lkButton";
import { activePage } from "js/activePage";
import { Link, useLocation } from "react-router-dom";
import { ROUTES_PATHS } from "const";

import "../styles/header.css";
import "../styles/lkLogin.css";
import "../styles/form.css";
import { useStores } from "hooks/useStores";

const Header = () => {
  const location = useLocation();
  const headerRef = useRef(null);
  const { modalStore } = useStores();

  // TODO: Переписать нормально после демо 03.06.2024
  /* Костылища из старой реализации начались */
  const handleClickBurger = () => {
    const sidebar = document.querySelector(".sidebar");
    const page = document.querySelector("html");
    const body = document.querySelector("body");

    if (sidebar?.classList.contains("sidebar--show")) {
      sidebar?.classList.remove("sidebar--show");
      sidebar?.classList.add("sidebar--hide");
      page.style.overflow = "auto";
      body.style.overflow = "auto";
      headerRef.current.style = "padding-right: 20px";
    } else {
      if (sidebar?.classList.contains("sidebar--hide")) {
        sidebar?.classList.remove("sidebar--hide");
        sidebar?.classList.add("sidebar--show");
        page.style.overflow = "hidden";
        headerRef.current.style = "padding-right: 26px";
      } else {
        sidebar?.classList.add("sidebar--show");
        page.style.overflow = "hidden";
        headerRef.current.style = "padding-right: 20px";
      }
    }
  };

  /* 
    Чтобы при изменении ширины монитора, не проигрывалась анимация
    убирания сайдбара, он, при ресайзе, не получает никаких доп.
    классов. Т.е. в "sidebar" нет транзишина, а в классах с
    модификаторами "show" и "hide" есть. При первом показывании
    сайдбара он зациклится между модификаторами, однако,
    при выходе из "мобильного" разрешения, модификаторы убираются,
    что опять же не дает анимацию.
  */
  const onScreenResize = () => {
    const sidebar = document.querySelector(".sidebar");
    const page = document.querySelector("html");
    const body = document.querySelector("body");
    if (window.innerWidth > 1024) {
      sidebar?.classList.remove("sidebar--show");
      sidebar?.classList.remove("sidebar--hide");
      page.style.overflow = "auto";
      body.style.overflow = "auto";
      headerRef.current.style = "";
    }
  };

  const onEscapeKeyUp = (evt) => {
    const sidebar = document.querySelector(".sidebar");

    if (evt.code === "Escape" && sidebar?.classList.contains("sidebar--show")) {
      sidebar?.classList.remove("sidebar--show");
      sidebar?.classList.add("sidebar--hide");
    }
  };

  useEffect(() => {
    window.addEventListener("resize", onScreenResize);
    window.addEventListener("keyup", onEscapeKeyUp);

    return () => {
      window.removeEventListener("resize", onScreenResize);
      window.removeEventListener("keyup", onEscapeKeyUp);
    };
  }, []);
  /* Костылища из старой реализации закончились */

  useEffect(() => {
    activePage();
  }, [location]);

  const handleClickCall = () => {
    modalStore.open("callback");
  }

  return (
    <div id='header' ref={headerRef}>
      <div className='container'>
        <div className='header-wrap'>
          <div className='header-left'>
            <Link className='header__link-logo' to='/'>
              <img
                className='header__img-logo'
                src={logo}
                width='100'
                loading='lazy'
                alt='Пак Пакыч'
              />
            </Link>
            <nav className='header-nav'>
              <ul className='header-nav-list'>
                <li className='header-nav-list__item'>
                  <Link
                    to={ROUTES_PATHS.MAIN}
                    className='header-nav-list__link'
                  >
                    Главная
                  </Link>
                </li>
                <li className='header-nav-list__item'>
                  <Link
                    to={ROUTES_PATHS.USEFUL}
                    className='header-nav-list__link'
                  >
                    Полезная информация
                  </Link>
                </li>
                <li className='header-nav-list__item'>
                  <Link
                    to={ROUTES_PATHS.CERTIFICATES}
                    className='header-nav-list__link'
                  >
                    Сертификаты
                  </Link>
                </li>
                <li className='header-nav-list__item'>
                  <Link
                    to={ROUTES_PATHS.DELIVERY}
                    className='header-nav-list__link'
                  >
                    Доставка и оплата
                  </Link>
                </li>
                <li className='header-nav-list__item'>
                  <Link
                    to={ROUTES_PATHS.CONTACTS}
                    className='header-nav-list__link'
                  >
                    Контакты
                  </Link>
                </li>
              </ul>
            </nav>
          </div>
          <div className='header-right'>
            <div className='header-action'>
              <div className='header-action-buttons'>
                <a href='tel:+74951201251'>+7 (495) 120 12 51 </a>
                <span className='vertical-dash'>| </span>
                <button className="header-action-button" onClick={handleClickCall}>Заказать звонок</button>
              </div>
              <div className='header-action-basket '>
                <Basket isHeader={true} />
              </div>
              <div className='header-action-lk'>
                <LkButton/>
              </div>
              <button
                className='header-dropdown__btn'
                type='button'
                onClick={handleClickBurger}
              >
                <svg
                  width='100%'
                  height='100%'
                  viewBox='0 0 48 48'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                    d='M7.94977 11.9498H39.9498'
                    stroke='black'
                    strokeWidth='4'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  ></path>
                  <path
                    d='M7.94977 23.9498H39.9498'
                    stroke='black'
                    strokeWidth='4'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  ></path>
                  <path
                    d='M7.94977 35.9498H39.9498'
                    stroke='black'
                    strokeWidth='4'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  ></path>
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export { Header };
